<template>
    <div class="d-flex flex-row h-2em toggle overflow-hidden justify-content-start rounded border"
         :class="{'cursor-pointer': !disabled}"
         @click="toggle(disabled)">
        <div class="tile"
             :class="{'bg-secondary': disabled, [active]: !disabled, 'inactive': !value}">
            <i class="fas" :class="[iconActive]"/>
        </div>
        <div class="tile bg-white"/>
        <div class="tile" :class="{'bg-secondary': disabled}">
            <i class="fas" :class="[iconInactive]"/>
        </div>
        <input v-if="name" :name="name" type="checkbox" class="d-none" :value="value">
    </div>
</template>

<script>
export default {
    props: {
        value: [Boolean, Number],
        name: {
            type: String,
            default: null,
        },
        iconActive: {
            type: String,
            default: 'fa-check',
        },
        iconInactive: {
            type: String,
            default: 'fa-times',
        },
        active: {
            type: String,
            default: 'bg-success',
        },
        inactive: {
            type: String,
            default: '',
        },
        confirmDisable: {
            type: [String, Boolean],
            default: false,
        },
        confirmDisableMessage: '',
        disabled: Boolean,
    },

    methods: {
        toggle(disabled) {
            if (!disabled) {
                if (this.confirmDisable && (this.value === true || this.value === 1)) {
                    Swal.fire({
                        title: this.confirmDisable || this.__('product.continue'),
                        showDenyButton: false,
                        showCancelButton: true,
                        confirmButtonText: this.__('actions.confirm'),
                        cancelButtonText: this.__('actions.abort'),
                        html: this.confirmDisableMessage,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.$emit('input', !this.value);
                        }
                    });
                } else {
                    this.$emit('input', !this.value);
                }
            }
        },
    },
};
</script>

<style>
.toggle {
    width: 80px;
}

.inactive {
    margin-left: -50%;
}

.tile {
    width: 50%;
    text-align: center;
    line-height: 15px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: white;
    background: #ccc;
    transition: .13s;
}
</style>
